import Backdrop from "../../components/global/Backdrop";
import Spacer from "../../components/global/Spacer";
import styled from "styled-components";
import tiktokConnect from "assets/icons/connect_tiktok.png";
import youtubeConnect from "assets/icons/connect-youtube-group.png";
import twitterConnect from "assets/icons/connect-twitter-group.png";
import Button from "components/global/Button";
import { useLocation, useParams, useHistory } from "react-router-dom";

const Wrapper = styled(Backdrop)`
  background-color: rgba(7, 7, 12, 0.5);

  .card {
    width: 480px;
    padding: 48px;
    background-color: var(--white);
    border-radius: 16px;

    .description {
      font-size: 16px;
      font-style: normal;
      font-weight: 450;
      line-height: 24px;
    }
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 24px);
      padding: 24px;

      .description {
        font-size: 14px;
        font-style: normal;
        font-weight: 450;
      }
    }

    .header {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
    }

    button {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
    }
  }
`;

const platformImgMap = {
  twitter: twitterConnect,
  youtube: youtubeConnect,
  tiktok: tiktokConnect,
};

const ConnectionFailureModal = ({path}) => {
  const { search } = useLocation();
  const platform = new URLSearchParams(search).get("platform");
  const connectedWorkspace = new URLSearchParams(search).get("name");
  const { brandId } = useParams();
  const history = useHistory();

  return (
    <Wrapper
      className={`flexRow alignCenter justifyCenter ${
        platform && connectedWorkspace && "show"
      }`}
    >
      <div className="card">
        <img
          src={platformImgMap[platform]}
          alt="."
          height="auto"
          width="140px"
        />
        <Spacer y={2.4} />
        <h5 className="header">
          {platform === "twitter"
            ? "Twitter profile connection failed"
            : platform === "youtube"
            ? "YouTube channel connection failed"
            : platform === "tiktok"
            ? "TikTok account connection failed"
            : ""}
        </h5>
        <Spacer y={0.6} />
        <p className="description colorBodyText">
          This{" "}
          {platform === "twitter"
            ? "profile"
            : platform === "youtube"
            ? "channel"
            : platform === "tiktok"
            ? "account"
            : ""}{" "}
          is connected to{" "}
          <strong className="colorGrey1">{connectedWorkspace}</strong> workspace
          on PostPaddy. Contact the workspace owner to add this profile.
        </p>
        <Spacer y={2.4} />
        <Button
          text="Done"
          fullWidth
          onClick={() => history.push(path ?? `/dashboard/brands/${brandId}/channels`)}
        />
      </div>
    </Wrapper>
  );
};

export default ConnectionFailureModal;
